"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridList = exports.VideoPlayIcon = exports.VideoPlayIconWrapper = exports.HasMoreWrapper = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _GridList = _interopRequireDefault(require("@material-ui/core/GridList"));

var _VideoPlay = _interopRequireDefault(require("../../theme/icons/VideoPlay"));

var _colors = _interopRequireDefault(require("../../theme/colors"));

var _utils = _interopRequireDefault(require("../../theme/utils"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    flex: 1;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    font-size: 48px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    flex: 1;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    flex: 1;\n    background-color: rgba(", ", 0.2);\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var HasMoreWrapper = (0, _styledComponents["default"])(_Grid["default"])(_templateObject(), _utils["default"].hexToRGB(_colors["default"].blackberry[700]), _colors["default"].lychee[100]);
exports.HasMoreWrapper = HasMoreWrapper;
var VideoPlayIconWrapper = (0, _styledComponents["default"])(_Grid["default"])(_templateObject2());
exports.VideoPlayIconWrapper = VideoPlayIconWrapper;
var VideoPlayIcon = (0, _styledComponents["default"])(_VideoPlay["default"])(_templateObject3());
exports.VideoPlayIcon = VideoPlayIcon;
var GridList = (0, _styledComponents["default"])(_GridList["default"])(_templateObject4());
exports.GridList = GridList;